import React, {useState, useEffect, useMemo} from 'react';
import {getTrackPlanButton} from "@/services/saleOpServices.ts";
import {Button} from "antd";

interface DataElementProps {
  id: string;
  btns: any[];
  data: any[];
  type?: string;
  duty: string;
  handleopenAllowcateModal: (...rest) => void
}

const DataElement = (props: DataElementProps) => {
  const {id, type='link', data, duty,handleopenAllowcateModal} = props
  const [btns, setBtns] = useState(props.btns || []);

  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      if (!id) {
        return;
      }

      try {
        const response = await getTrackPlanButton(id);

        if (isMounted) {
          setBtns([...btns, ...response])
        }
      } catch (error) {

      }
    };

    fetchData();

    return () => {
      isMounted = false;
    };
  }, [id]);

  const current = useMemo(() => {
    const currentBtn = btns?.find(btn => btn.duty === duty) || {}
    const isFind = data.find(item => item.dutyType === currentBtn.duty)
    console.log(btns, isFind, duty)
    if (isFind) {
      return <Button
        type={type}
        style={{ height: '22px', paddingTop: 0, paddingBottom: 0 }}
        onClick={() => handleopenAllowcateModal(currentBtn.buttonKey, isFind.trackPlanNodeId, isFind.trackPlanId)}
      >改派</Button>;
    }
    return null
  }, [btns])

  return (
      <div data-testid="content">
        {current}
      </div>
  );
};

export default DataElement;